<template>
  <div justify="center" class="pl-lg-10" >
    <div>
      <h1>Σχετικά με την υπηρεσία.</h1>
      <p class="pt-4">
        {{ loginText }}
        <strong>
          Για εγγραφή στην υπηρεσία αυτή, επικοινωνήστε με το τεχνικό μας
          γραφείο!
        </strong>
      </p>
      <div style="display:flex">
        <v-btn
            v-if="loginLink"
            target="_blank"
            :href="loginLink"
            color="primary"
            large
        >
          ΕΓΓΡΑΦΗ
        </v-btn>
        <install-button></install-button>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Sidebar from "@/wl-core/components/Sidebar";
import InstallButton from "./InstallButton";

export default {
  name: "FrontPageInfo",
  components: {InstallButton, Sidebar},
  data: () => ({
    loginText:
      "Το WinLift Managers (https://managers.winlift.gr) είναι μια διαδικτυακή εφαρμογή όπου μπρορείτε να ενημερώνεστε σχετικά με τα ανυψωτικά σας, τις οφειλές σας, αλλά και να στείλετε αιτήματα και βλάβες κατευθείαν στο γραφείο μας χωρίς να χρειάζονται τηλέφωνα.",
    loginLink: null,
  }),
  computed: {
    ...mapState(["subdomain"]),
  },
  methods: {
    ...mapActions(["getFrontPageDetails"]),
  },
  created() {
    this.getFrontPageDetails(this.subdomain).then((resp) => {
      if (resp.LoginText) this.loginText = resp.LoginText;
      if (resp.LoginLink) this.loginLink = resp.LoginLink;
    });
  },
  props: {
    hideToolbar: { type: Boolean, default: null, required: false },
  },
};
</script>
<style>

</style>